var jQuery = $ = global.jQuery;

import './scss/index.scss';
import feather from 'feather-icons';

if( module.hot ) {
  module.hot.accept(() => {
    window.location.reload();
  })
}

class App {
  constructor() {
    feather.replace();
  }
}

$(document).ready(function() {
  new App();
})